function Header({ question, status }) {
  return (
    <header className="app-header">
      <img
        src={
          status === "ready" || status === "finished"
            ? "favicon.png"
            : `/img/${question.imageID}.png`
        }
        alt={question.question}
      />
      <h1>The Traffic Sign Quiz</h1>
    </header>
  );
}

export default Header;
